/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Administrator_HintInputs */



/**
* | output |
* | --- |
* | "Members with this permission will have every permission and will also bypass all channel specific permissions or restrictions (for example, these members wou..." |
*
* @param {Leveling_Perm_Administrator_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_administrator_hint = /** @type {((inputs?: Leveling_Perm_Administrator_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Administrator_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участники с этим правом получают все права и обходят любые права и ограничения отдельных каналов (например, получают доступ ко всем приватным каналам). Выдавать это право опасно.")
	return /** @type {LocalizedString} */ ("Members with this permission will have every permission and will also bypass all channel specific permissions or restrictions (for example, these members would get access to all private channels). This is a dangerous permission to grant.")
});